var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrContainer mx-auto",style:({width: _vm.size+10+'px'})},[_c('qrcode-vue',{staticClass:"mb-0",attrs:{"value":_vm.qrValue,"size":_vm.size,"level":"H"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }